import { render, staticRenderFns } from "./AppEmptyList.vue?vue&type=template&id=25bb4c0c&scoped=true&lang=pug&"
import script from "./AppEmptyList.vue?vue&type=script&lang=js&"
export * from "./AppEmptyList.vue?vue&type=script&lang=js&"
import style0 from "./AppEmptyList.vue?vue&type=style&index=0&id=25bb4c0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bb4c0c",
  null
  
)

export default component.exports